import { render } from "./ListaBugs.vue?vue&type=template&id=4bb4ab96"
import script from "./ListaBugs.vue?vue&type=script&lang=js"
export * from "./ListaBugs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__